<script setup lang="ts">
import { SelectorField } from '@rfc/rfc-components-library'
import { type SelectorObject } from '@rfc/rfc-components-library/types'
import * as momentTz from 'moment-timezone'
import { computed, ref } from 'vue'

type Props = {
    timezone?: string
}
defineProps<Props>()

const emit = defineEmits<{
    (e: 'change', value: string): void
}>()

const timezones = momentTz.tz.names().map(value => ({ value, label: value }))

const typedTz = ref<string>()
const filteredTimezones = computed(() =>
    timezones.filter(item => item.value.toLowerCase().includes(typedTz.value?.toLowerCase() ?? ''))
)

const handleChangeTz = (value: SelectorObject) => {
    emit('change', value?.value as string)
    typedTz.value = undefined
}
</script>

<template>
    <SelectorField
        :label="$t('common.tz')"
        :modelValue="filteredTimezones.find(item => item.label === timezone)?.value"
        @typing="typedTz = $event"
        @select="handleChangeTz"
        :clearable="false"
        :options="filteredTimezones"
        required
        class="w-full" />
</template>
